module.exports = __webpack_public_path__ + "img/SPX1.ad60a0cf.png";